import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export function Counter(props: { label: string; value: string }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" display="block">
        {props.label}
      </Typography>
      <Typography variant="h6" sx={{ fontVariantNumeric: "tabular-nums" }}>
        {props.value}
      </Typography>
    </Box>
  );
}
